import axios from "axios";
import { BASE_URL } from "../utility/BaseUrl";

const Request = async (
  headers = {},
  method = "get",
  params = "",
  data = ""
) => {
  const url = BASE_URL + params;
  try {
    const response = await axios({
      method,
      url,
      headers,
      data: data,
    });
    return response.data;
  } catch (error) {
    console.log("-*-***-**--*-*-*-*-**-**--*-*-*-*-*-**--*-");
    if (error?.response?.status === 401) return { status: 401, error: error };
    return { status: 0, error: error };
  }
};

export default Request;
